/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Success_BodyInputs */

const en_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your declaration was received at the server time shown below. This receipt does not disclose account matching or eligibility; a separate processing outcome may follow.`)
};

const de_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Erklärung ist zum unten genannten Serverzeitpunkt eingegangen. Diese Bestätigung gibt keine Auskunft über Kontozuordnung oder Anspruch; eine gesonderte Bearbeitungsmitteilung kann folgen.`)
};

const fr_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre déclaration a été reçue à l’heure serveur indiquée. Ce reçu ne révèle ni correspondance de compte ni éligibilité ; une décision de traitement suivra éventuellement.`)
};

const es_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu declaración se recibió a la hora del servidor indicada. El justificante no revela coincidencia de cuenta ni elegibilidad; el resultado de tramitación puede llegar después.`)
};

const it_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dichiarazione è stata ricevuta all’ora server indicata. La ricevuta non rivela corrispondenza dell’account o idoneità; potrà seguire l’esito.`)
};

const nl_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je verklaring is ontvangen op de vermelde servertijd. Dit bewijs onthult geen accountmatch of recht; een verwerkingsuitkomst kan volgen.`)
};

const pl_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oświadczenie otrzymano o podanym czasie serwera. Potwierdzenie nie ujawnia dopasowania konta ani uprawnienia; wynik obsługi może nadejść później.`)
};

const fi_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitus vastaanotettiin alla näkyvänä palvelinaikana. Kuitti ei paljasta tilin vastaavuutta tai oikeutta; käsittelytulos voi seurata.`)
};

const da_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din erklæring blev modtaget på den viste servertid. Kvitteringen afslører ikke kontomatch eller ret; et behandlingsresultat kan følge.`)
};

const sv_consumer_declaration_success_body = /** @type {(inputs: Consumer_Declaration_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din förklaring mottogs vid den visade servertiden. Kvittot avslöjar inte kontomatchning eller rätt; ett behandlingsbesked kan följa.`)
};

/**
* | output |
* | --- |
* | "Your declaration was received at the server time shown below. This receipt does not disclose account matching or eligibility; a separate processing outcome m..." |
*
* @param {Consumer_Declaration_Success_BodyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_success_body = /** @type {((inputs?: Consumer_Declaration_Success_BodyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Success_BodyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_success_body(inputs)
	if (locale === "fr") return fr_consumer_declaration_success_body(inputs)
	if (locale === "es") return es_consumer_declaration_success_body(inputs)
	if (locale === "it") return it_consumer_declaration_success_body(inputs)
	if (locale === "nl") return nl_consumer_declaration_success_body(inputs)
	if (locale === "pl") return pl_consumer_declaration_success_body(inputs)
	if (locale === "fi") return fi_consumer_declaration_success_body(inputs)
	if (locale === "da") return da_consumer_declaration_success_body(inputs)
	if (locale === "sv") return sv_consumer_declaration_success_body(inputs)
	return en_consumer_declaration_success_body(inputs)
});